import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from './user-data';
import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";

@Injectable()
export class BlockingtimeData {
  data: any;
  viewmode:string;
  updateRequired:boolean;
  constructor(public http: Http
            , public common: CommonData
            , public userData: UserData
            ) {}
  clear(){
    this.data.length = 0;
  }
  load() {
    return new Promise(resolve => {
      var data = JSON.stringify({
            viewmode: this.viewmode,
            token: this.userData.jwt
        });
    
      this.http.post(this.common.baseurl+'blockingtimes/getassigned',data)
        .subscribe(data => {
          this.data = data.json().data;
          
          this.updateRequired = false;

        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });
    });



  }
  create(data){
    return new Promise(resolve => {
    
      this.http.post(this.common.baseurl+'blockingtimes/createmultiplepps',data)
        .subscribe(data => {
          let response = data.json();
          this.updateRequired = true;
          if(response.success === true){
              console.log(response);

          }
          else{
            /*
            let toast = this.toastCtrl.create({
              message: 'Login nicht erfolgreich',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();     
            */       
            console.log("fehler");
          }
        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });
    });
  }
  update(data){
    return new Promise(resolve => {
    
      this.http.post(this.common.baseurl+'blockingtimes/updatemultiplepps',data)
        .subscribe(data => {
          let response = data.json();
          this.updateRequired = true;
          if(response.success === true){
              console.log(response);

          }
          else{
            /*
            let toast = this.toastCtrl.create({
              message: 'Login nicht erfolgreich',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();     
            */       
            console.log("fehler");
          }
        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });
    });
  }
  delete(btids){
    console.log(btids);
    return new Promise(resolve => {
      var data = JSON.stringify({
            btids: btids,
            token: this.userData.jwt
        });
    
      this.http.post(this.common.baseurl+'blockingtimes/deletemultiplepps',data)
        .subscribe(data => {
          let response = data.json();
          this.updateRequired = true;
          if(response.success === true){
          }
          else{
            /*
            let toast = this.toastCtrl.create({
              message: 'Login nicht erfolgreich',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();     
            */       
          }
        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/blockingtime-data.ts